const colors = {
  transparent: 'transparent',
  current: 'currentColor',
  black: '#09090B',
  white: '#FFFFFF',
  whiteAlpha: {
    50: 'rgba(255, 255, 255, 0.04)',
    100: 'rgba(255, 255, 255, 0.06)',
    200: 'rgba(255, 255, 255, 0.08)',
    300: 'rgba(255, 255, 255, 0.16)',
    400: 'rgba(255, 255, 255, 0.24)',
    500: 'rgba(255, 255, 255, 0.36)',
    600: 'rgba(255, 255, 255, 0.48)',
    700: 'rgba(255, 255, 255, 0.64)',
    800: 'rgba(255, 255, 255, 0.80)',
    900: 'rgba(255, 255, 255, 0.92)',
    950: 'rgba(255, 255, 255, 0.95)',
  },
  blackAlpha: {
    50: 'rgba(0, 0, 0, 0.04)',
    100: 'rgba(0, 0, 0, 0.06)',
    200: 'rgba(0, 0, 0, 0.08)',
    300: 'rgba(0, 0, 0, 0.16)',
    400: 'rgba(0, 0, 0, 0.24)',
    500: 'rgba(0, 0, 0, 0.36)',
    600: 'rgba(0, 0, 0, 0.48)',
    700: 'rgba(0, 0, 0, 0.64)',
    800: 'rgba(0, 0, 0, 0.80)',
    900: 'rgba(0, 0, 0, 0.92)',
    950: 'rgba(0, 0, 0, 0.95)',
  },
  gray: {
    50: '#F5FAFD',
    100: '#D8DFEC',
    200: '#BEC8DE',
    300: '#AAB6D0',
    400: '#95A1BB',
    500: '#828EA8',
    600: '#737C97',
    700: '#606A82',
    800: '#4D596F',
    900: '#3A485D',
    950: '#2D374B',
  },
  red: {
    50: '#FEF2F2',
    100: '#FEE2E2',
    200: '#FECACA',
    300: '#FCA5A5',
    400: '#F87171',
    500: '#EF4444',
    600: '#DC2626',
    700: '#991919',
    800: '#511111',
    900: '#300C0C',
    950: '#1F0808',
  },
  orange: {
    50: '#FFF7ED',
    100: '#FFEDD5',
    200: '#FED7AA',
    300: '#FDBA74',
    400: '#FB923C',
    500: '#F97316',
    600: '#EA580C',
    700: '#92310A',
    800: '#6C2710',
    900: '#3B1106',
    950: '#220A04',
  },
  yellow: {
    50: '#FEFCE8',
    100: '#FEF9C3',
    200: '#FEF08A',
    300: '#FDE047',
    400: '#FACC15',
    500: '#EAB308',
    600: '#CA8A04',
    700: '#845209',
    800: '#713F12',
    900: '#422006',
    950: '#281304',
  },
  green: {
    50: '#E5FAEC',
    100: '#CBF6D9',
    200: '#93ECB0',
    300: '#5FE28A',
    400: '#2BD964',
    500: '#1EA74B',
    600: '#18863C',
    700: '#12632D',
    800: '#0C411D',
    900: '#062310',
    950: '#031108',
  },
  teal: {
    50: '#E9FBF4',
    100: '#D4F7EA',
    200: '#A8EBD4',
    300: '#80DFC0',
    400: '#5BD2AD',
    500: '#3ABD96',
    600: '#2B9C79',
    700: '#1E7659',
    800: '#124F3A',
    900: '#082B1E',
    950: '#04160F',
  },
  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    200: '#BFDBFE',
    300: '#A3CFFF',
    400: '#60A5FA',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#173DA6',
    800: '#1A3478',
    900: '#14204A',
    950: '#0C142E',
  },
  cyan: {
    50: '#ECFEFF',
    100: '#CFFAFE',
    200: '#A5F3FC',
    300: '#67E8F9',
    400: '#22D3EE',
    500: '#06B6D4',
    600: '#0891B2',
    700: '#0C5C72',
    800: '#134152',
    900: '#072A38',
    950: '#051B24',
  },
  purple: {
    50: '#F3EEFF',
    100: '#E7DEFF',
    200: '#D4C3FF',
    300: '#BEA5FF',
    400: '#A987FF',
    500: '#946AFF',
    600: '#7E46FF',
    700: '#671CFA',
    800: '#4A23BA',
    900: '#2C0376',
    950: '#1C004D',
  },
  pink: {
    50: '#FDF2F8',
    100: '#FCE7F3',
    200: '#FBCFE8',
    300: '#F9A8D4',
    400: '#F472B6',
    500: '#EC4899',
    600: '#DB2777',
    700: '#A41752',
    800: '#6D0E34',
    900: '#45061F',
    950: '#2C0514',
  },
}

export default colors
